import type { AppState } from 'state/state.model';

export function getUserNotifications(state: AppState) {
  return state.userNotifications;
}
